/* tslint:disable:no-empty */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function noop() { }
//# sourceMappingURL=noop.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/util/noop.js
// module id = 141
// module chunks = 0